import React from 'react'
import cx from 'classnames'
import { useIntl } from 'react-intl'

import { useAccounts } from '@/components/Providers/AccountsProvider'
import { ACCOUNT_BILLING_STATUSES, SUBSCRIPTION_STATUSES } from '@/constants'

import styles from './StatusLabel.module.scss'

export default function StatusLabel() {
  const { formatMessage } = useIntl()
  const { account: { billingStatus }, subscriptions: [base] } = useAccounts()

  const isPastDue = billingStatus === ACCOUNT_BILLING_STATUSES.PAST_DUE

  const isDanger =
    [SUBSCRIPTION_STATUSES.EXPIRED, SUBSCRIPTION_STATUSES.FAILED].includes(
      base.status,
    ) || isPastDue

  const isWarning = [
    SUBSCRIPTION_STATUSES.CANCELED,
    SUBSCRIPTION_STATUSES.PAUSED,
    SUBSCRIPTION_STATUSES.FUTURE,
  ].includes(base.status)

  const isSuccess = base.status === SUBSCRIPTION_STATUSES.ACTIVE
  const isNonRenewingPlan = !!(base.plan?.isTrial && !base.plan.requiresBilling)
  const displayBaseStatus = base.status === SUBSCRIPTION_STATUSES.CANCELED && isNonRenewingPlan
    ? formatMessage({ id: 'accountBillingStatus.expiring' })
    : base.status

  return (
    <strong className={cx(
      styles.statusLabel,
      isSuccess && styles.isSuccess,
      isWarning && styles.isWarning,
      isDanger && styles.isDanger,
    )}
    >{isPastDue ? formatMessage({ id: `accountBillingStatus.${billingStatus}` }) : displayBaseStatus}
    </strong>
  )
}
